import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chatData: null,
  triggers: null,
  language: "en",
  languageTexts: null,
  selectedQuestion: "",
  questionPicked: "",
  questionStatus: "",
  answer: "",
  name: "",
  firstName: "",
  lastName: "",
  phoneNumber: "",
  selectedOrganization: null,
  questionId: null,
  customActionData: "",
  clientUIXToken: "",
  uixFormDescription: "",
  // Chat flow state
  listQuestions: [],
  questionType: "",
  itemId: null,
  parentURL: null,
  triggerId: null,
};

const connectChatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setChatData: (state, action) => {
      state.chatData = action.payload;
    },
    setTriggers: (state, action) => {
      state.triggers = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setLanguageTexts: (state, action) => {
      state.languageTexts = action.payload;
    },
    setSelectedQuestion: (state, action) => {
      state.selectedQuestion = action.payload;
    },
    setQuestionPicked: (state, action) => {
      state.questionPicked = action.payload;
    },
    setQuestionStatus: (state, action) => {
      state.questionStatus = action.payload;
    },
    setAnswer: (state, action) => {
      state.answer = action.payload;
    },
    setName: (state, action) => {
      state.name = action.payload;
    },
    setFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setLastName: (state, action) => {
      state.lastName = action.payload;
    },
    setPhoneNumber: (state, action) => {
      state.phoneNumber = action.payload;
    },
    setSelectedOrganization: (state, action) => {
      state.selectedOrganization = action.payload;
    },
    setQuestionId: (state, action) => {
      state.questionId = action.payload;
    },
    setCustomActionData: (state, action) => {
      state.customActionData = action.payload;
    },
    setClientUIXToken: (state, action) => {
      state.clientUIXToken = action.payload;
    },
    setUixFormDescription: (state, action) => {
      state.uixFormDescription = action.payload;
    },
    setListQuestions: (state, action) => {
      state.listQuestions = action.payload;
    },
    setQuestionType: (state, action) => {
      state.questionType = action.payload;
    },
    setItemId: (state, action) => {
      state.itemId = action.payload;
    },
    setParentURL: (state, action) => {
      state.parentURL = action.payload;
    },
    setTriggerId: (state, action) => {
      state.triggerId = action.payload;
    },
    resetChatState: (state) => {
      state.selectedQuestion = "";
      state.questionPicked = "";
      state.questionStatus = "";
      state.answer = "";
      state.phoneNumber = "";
      state.selectedOrganization = null;
      state.questionId = null;
      state.questionType = "";
    },
  },
});

export const {
  setChatData,
  setTriggers,
  setLanguage,
  setLanguageTexts,
  setSelectedQuestion,
  setQuestionPicked,
  setQuestionStatus,
  setAnswer,
  setName,
  setFirstName,
  setLastName,
  setPhoneNumber,
  setSelectedOrganization,
  setQuestionId,
  setCustomActionData,
  setClientUIXToken,
  setUixFormDescription,
  setListQuestions,
  setQuestionType,
  setItemId,
  setParentURL,
  setTriggerId,
  resetChatState,
} = connectChatSlice.actions;

export default connectChatSlice.reducer;
